import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import { v4 as uuidv4 } from 'uuid';
export class SearchBox extends Component {

  static propTypes = {
    options: PropTypes.any,
    history: PropTypes.object,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    onSearch: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.func
    ]),
    selectedOption: PropTypes.object,
    txtSearch: PropTypes.string,
    onChangeOption: PropTypes.func,
    onChangeInput: PropTypes.func
  }
  constructor(props) {
    super(props);

    this.id = uuidv4();

    this.state = { value: '', selectedOption: null };
  }

  componentDidMount() {
    /*this.setState({
      selectedOption: this.props.selectedOption
    });*/

    // var me = this;
    // me.props.options.forEach(item => {
    //   if (item.selected && me.state.selectedOption === null) {
    //     me.setState({ selectedOption: item });
    //     return;
    //   }
    // });
    // $.each(me.props.options, function(i, item) {
    //   if (item.selected && me.state.selectedOption === null) {
    //     me.setState({ selectedOption: item });
    //     return;
    //   }
    // });

  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.txtSearch,
      selectedOption: nextProps.selectedOption
    });
  }

  onSelected(e, item) {
    this.setState({
      selectedOption: item
    }, () => {
      this.props.onChangeOption(this.state.selectedOption);
    });
  }

  handleChange = (event) => {
    event.preventDefault();
    this.setState({
      value: this.txtSearch.value
    }, () => {
      this.props.onChangeInput(this.state.value);
    });
  }

  onSearch(e) {

    this.setState({ value: $('#' + this.id).val() });

    setTimeout(() => {
      this.props.onSearch(e, this.state);
    }, 0);

  }

  onEnter(e) {
    if (e.key === 'Enter') {
      this.onSearch(e);
    }
  }

  renderListItems() {
    let selectedValue = this.state.selectedOption ? this.state.selectedOption.value : '';
    let items = null;
    if (this.props.options.length > 0) {
      items = this.props.options.map(item => {
        return <li onClick={(e) => { this.onSelected(e, item); }} className={item.value === selectedValue ? 'active' : ''}>
          <a>{item.text}</a>
        </li>;
      });
    }

    return [<button type='button' className='btn btn-default dropdown-toggle'
      data-toggle='dropdown'
      aria-haspopup='true'
      aria-expanded='false'>{this.state.selectedOption ? this.state.selectedOption.text : 'All'} <span className='caret' /></button>,
    <ul className='dropdown-menu dropdown-menu-right'>
      <li>
        <ul className='menu-items'>
          {items}
        </ul>
      </li>
    </ul>];
  }

  render() {
    return <div className={['input-group search-box', this.props.className ? this.props.className : ''].join(' ')}>
      <input
        id={this.id}
        ref={(ref) => { this.txtSearch = ref; }}
        onKeyPress={this.onEnter.bind(this)}
        type='text'
        className='form-control search-input'
        aria-label='Search'
        value={this.state.value}
        placeholder={this.props.placeholder}
        onChange={this.handleChange.bind(this)} />
      <div className='input-group-btn'>
        {this.props.options && this.props.options.length && this.renderListItems()}
        <button className='btn btn-default search-btn' type='button' onClick={this.onSearch.bind(this)}><span className='glyphicon glyphicon-search' aria-hidden='true' /></button>
      </div>
    </div>;
  }
}




// WEBPACK FOOTER //
// ./src/components/searchbox/index.js